import {
  createMockTransaction,
  listMockTransactions,
  updateMockTransactionStatus,
} from "./mockPaymentsStore.js";

export const mockGateway = {
  provider: "mock",

  async createCheckoutSession({ userId, userEmail, items, paymentMethod }) {
    const transaction = createMockTransaction({
      userId,
      userEmail,
      items,
      paymentMethod,
    });

    return {
      transaction,
      redirectUrl: null,
    };
  },

  async listPayments({ userId }) {
    return listMockTransactions(userId);
  },

  async updatePaymentStatus({ transactionId, status }) {
    return updateMockTransactionStatus(transactionId, status);
  },
};
